
import { useState } from 'react';

export default function Booking() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleTextSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!phoneNumber || isSubmitting) return;

    setIsSubmitting(true);
    setShowError(false);

    try {
      const response = await fetch('https://readdy.ai/api/form/d66h18c8e72clamqhg10', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          phone: phoneNumber,
          request: 'Customer wants to text photos for a quick junk removal quote',
        }).toString(),
      });

      if (response.ok) {
        setShowSuccess(true);
        setPhoneNumber('');
        setTimeout(() => {
          setShowSuccess(false);
        }, 4000);
      } else {
        setShowError(true);
        setTimeout(() => setShowError(false), 4000);
      }
    } catch {
      setShowError(true);
      setTimeout(() => setShowError(false), 4000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="booking" className="py-20 bg-[#1F2937]">
      <div className="max-w-4xl mx-auto px-6">
        {/* Main CTA Headline */}
        <div className="text-center mb-12">
          <h2 className="text-5xl lg:text-6xl font-serif text-white mb-6">Clear Your Space Today</h2>
          <p className="text-lg text-[#9CA3AF]">Choose your preferred way to connect</p>
        </div>

        {/* Contact Method Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Phone Card */}
          <div className="bg-white/10 rounded-2xl p-8 hover:bg-white/15 transition-all cursor-pointer text-center">
            <div className="w-12 h-12 bg-[#FF6B4A] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-phone-fill text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-bold text-xl mb-3">Call Now</h3>
            <p className="text-[#9CA3AF] text-sm mb-4">Speak with our team</p>
            <a 
              href="tel:+15134489448" 
              className="text-white text-2xl font-bold hover:text-[#FF6B4A] transition-colors block"
            >
              (513) 448-9448
            </a>
          </div>

          {/* Online Booking Card */}
          <div className="bg-white/10 rounded-2xl p-8 hover:bg-white/15 transition-all cursor-pointer text-center">
            <div className="w-12 h-12 bg-[#FF6B4A] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-bold text-xl mb-3">Book Online</h3>
            <p className="text-[#9CA3AF] text-sm mb-4">Schedule instantly</p>
            <a 
              href="#contact" 
              className="inline-flex items-center gap-2 bg-[#FF6B4A] text-white px-6 py-3 rounded-full hover:bg-[#ff5533] transition-all whitespace-nowrap text-sm font-semibold"
            >
              Book Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Text Card */}
          <div className="bg-white/10 rounded-2xl p-8 hover:bg-white/15 transition-all text-center">
            <div className="w-12 h-12 bg-[#FF6B4A] rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-message-3-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-bold text-xl mb-3">Text Photos</h3>
            <p className="text-[#9CA3AF] text-sm mb-4">Get a fast quote</p>
            <form id="text-photos-form" data-readdy-form onSubmit={handleTextSubmit} className="flex gap-2">
              <input 
                type="tel"
                name="phone"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Your number" 
                required
                className="flex-1 bg-white/20 text-white placeholder-[#9CA3AF] px-4 py-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#FF6B4A]"
              />
              <button 
                type="submit"
                disabled={isSubmitting}
                className="bg-[#FF6B4A] text-white px-4 py-2 rounded-lg hover:bg-[#ff5533] transition-all whitespace-nowrap text-sm font-semibold cursor-pointer disabled:opacity-60"
              >
                {isSubmitting ? '...' : 'Send'}
              </button>
            </form>
            {showSuccess && (
              <p className="text-green-400 text-xs mt-2">We got your number — we&#39;ll text you shortly!</p>
            )}
            {showError && (
              <p className="text-red-400 text-xs mt-2">Something went wrong. Please try again or call us.</p>
            )}
          </div>
        </div>

        {/* Additional Info */}
        <div className="text-center mt-12">
          <p className="text-[#9CA3AF] text-sm">
            Available 7 days a week • Same-day service available • Free estimates
          </p>
        </div>
      </div>
    </section>
  );
}
